export { createElement } from './createElement';
export { getViewConfig } from './ViewConfig';
export { addIntentsToProps, createPropsFacade, mergeProperty, mergeProps } from './PropsFacade';

//# sourceMappingURL=index.js.map